<template>
  <el-form
    :model="form"
    ref="form"
    :disabled="disabledForm"
  >
    <div class="row">
      <div class="col-xl col-lg-4 col-md-6 col-12">
        <div class="row">
          <div class="col-12">
            <el-form-item
              :label="L10n('company-type')"
              prop="companyTypeID"
              :rules="rulesCompanyType"
              class="material-style">
              <select-response
                :model.sync="form.companyTypeID"
                :data="dataSourceCompanyType.records"
                :isLoading="dataSourceCompanyType.loading"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('zip-code')"
              prop="zipCode"
              class="material-style">
              <el-input
                :value="form.zipCode"
                @input="form.zipCode = valueTrimLeft($event)"
                @change="updateModelItem('zipCode', { required: false })"
              />
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('fax')"
              prop="zipCode"
              class="material-style">
              <el-input
                :value="form.fax"
                @input="form.fax = valueTrimLeft($event)"
                @change="updateModelItem('fax', { required: false })"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-xl col-lg-4 col-md-6 col-12">
        <div class="row">
          <div class="col-12">
            <el-form-item
              :label="L10n('street')"
              prop="street"
              class="material-style">
              <el-input
                :value="form.street"
                @input="form.street = valueTrimLeft($event)"
                @change="updateModelItem('street', { required: false })"
              />
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('state')"
              prop="state"
              class="material-style">
              <el-input
                :value="form.state"
                @input="form.state = valueTrimLeft($event)"
                @change="updateModelItem( 'state', { required: false })"
              />
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('phone')"
              prop="state"
              class="material-style">
              <el-input
                :value="form.phone"
                @input="form.phone = valueTrimLeft($event)"
                @change="updateModelItem('phone', { required: false })"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-xl col-lg-4 col-md-6 col-12">
        <div class="row">
          <div class="col-12">
            <el-form-item
              :label="L10n('city')"
              prop="city"
              class="material-style">
              <el-input
                :value="form.city"
                @input="form.city = valueTrimLeft($event)"
                @change="updateModelItem('city', { required: false })"
              />
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('address-type-division')"
              prop="addressTypeDivisionID"
              class="material-style">
              <select-response
                :model.sync="form.addressTypeDivisionID"
                @update:model="updateModelItem('addressTypeDivisionID', { required: false })"
                :data="dataSourceDivision.records"
                :isLoading="dataSourceDivision.loading"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('email')"
              prop="email"
              class="material-style">
              <el-input
                :value="form.email"
                @input="form.email = valueTrimLeft($event)"
                @change="updateModelItem('email', { required: false })"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-xl col-lg-6 col-md-6 col-12">
        <div class="row">
          <div class="col-12">
            <el-form-item
              :label="L10n('country')"
              prop="country"
              :rules="getValidationRule('required')"
              class="material-style">
              <el-input
                ref="firstField"
                :value="form.country"
                @input="form.country = valueTrimLeft($event)"
                @change="updateModelItem( 'country', { required: true })"/>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('score')"
              prop="scoreID"
              :rules="rulesScore"
              class="material-style">
              <select-response
                :model.sync="form.scoreID"
                :fields="{id: 'id', title: 'scoreText'}"
                :data="dataSourceScore.records"
                :isLoading="dataSourceScore.loading"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('vat-number')"
              prop="vatNumber"
              class="material-style">
              <el-input
                ref="firstField"
                :value="form.vatNumber"
                @input="form.vatNumber = valueTrimLeft($event)"
                @change="updateModelItem('vatNumber', { required: false })"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-xl col-lg-6 col-12">
        <div class="row">
          <div class="col-12">
            <el-form-item
              :label="L10n('bax-employee')"
              prop="baxEmployeeID"
              :rules="rulesBaxEmployee"
              class="material-style">
              <select-response
                :model.sync="form.baxEmployeeID"
                :fields="{id: 'id', title: 'name'}"
                :data="dataSourceEmployee.records"
                :isLoading="dataSourceEmployee.loading"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('remark')"
              prop="remark"
              class="material-style">
              <el-input
                ref="firstField"
                type="textarea"
                :rows="5"
                :value="form.remark"
                @input="form.remark = valueTrimLeft($event)"
                @change="updateModelItem('remark', { required: false })"
              />
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import mixListForm from '@/components/ListForm/mixForm'
import { ServiceCompanyDetail } from '@/services/CompanyDetails'

export default {
  name: 'FormDetails',
  mixins: [mixListForm, Form],
  props: {
    companyID: { required: true }
  },
  computed: {
    rulesCompanyType () {
      return [
        { validator: this.validatorCompanyType, trigger: 'change' }
      ]
    },
    rulesBaxEmployee () {
      return [
        { validator: this.validatorBaxEmployee, trigger: 'change' }
      ]
    },
    rulesScore () {
      return [
        { validator: this.validatorScore, trigger: 'change' }
      ]
    },
    dataSourceCompanyType () {
      return this.API('CompanyTypes/GetAllDynamic?select=id,title')
    },
    dataSourceDivision () {
      return this.API('Divisions/GetAllDynamic?select=id,title')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText&filter=scoreIndex==2&orderBy=scoreText asc')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name&filter=isActive==true')
    }
  },
  methods: {
    async validatorCompanyType (rule, value, callback) {
      if (value == null || value === '') {
        callback()
      }
      try {
        await ServiceCompanyDetail
          .checkExistNotMoreThanOne({ companyID: this.companyID, field: 'companyTypeID', detailID: this.form.id })
        callback()
      } catch (e) {
        callback(new Error(e.message))
      }
    },
    async validatorBaxEmployee (rule, value, callback) {
      if (value == null || value === '') {
        callback()
      }
      try {
        await ServiceCompanyDetail
          .checkExistNotMoreThanOne({ companyID: this.companyID, field: 'baxEmployeeID', detailID: this.form.id })
        callback()
      } catch (e) {
        callback(new Error(e.message))
      }
    },
    async validatorScore (rule, value, callback) {
      if (value == null || value === '') {
        callback()
      }
      try {
        await ServiceCompanyDetail
          .checkExistNotMoreThanOne({ companyID: this.companyID, field: 'scoreID', detailID: this.form.id })
        callback()
      } catch (e) {
        callback(new Error(e.message))
      }
    }
  }
}
</script>
